import { Box, Card, useMediaQuery } from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { STRAPI_API_URL } from "../../src/constant/appConstants";
import fetcher from "../../src/dataProvider";

const useStyles = makeStyles((theme) => ({
  fan__singerSlider: {
    marginTop: "-90px",
    "& .slick-slider": {
      backgroundColor: "#fff",
      padding: "27px 11px",
      borderRadius: "10px",
    },
    "& .slick-list": {
      paddingLeft: "0 !Important",
    },

    "& .slick-dots": {
      position: "absolute",
      bottom: "-38px",
      right: "-30px",
      width: "auto",
      "@media (max-width:767px)": {
        right: "0",
        left: "0",
      },

      "& li": {
        listStyle: "none",
        margin: "5px 0",
        display: "block",
        height: "15px",
        "@media (max-width:767px)": {
          display: "inline-block",
        },
      },

      "& button": {
        borderRadius: "50%",
        width: "12px",
        height: "12px",
        border: "none",
        border: "1px solid #fff",
        textIndent: "-9999px",
        outline: "0",
        "&:before": {
          backgroundColor: "#fff !important",
          borderRadius: "100%",
          width: "12px",
          height: "12px",
          opacity: "0",
        },
      },
    },
    "@media (max-width:767px)": {
      marginTop: "0",
    },
    "@media (max-width:480px)": {
      padding: "30px 0",
    },
  },
  fan__PartnersSection: {
    position: "relative",
    bottom: "100px",
    display: "flex",
    justifyContent: "space-between",
    columnGap: "20px",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "& card": {
      width: "100%",
    },
    "@media (max-width:1024px)": {
      bottom: "0",
    },
    "@media (max-width:767px)": {
      bottom: "0",
    },
    "@media (max-width:480px)": {
      display: " -webkit-box",
      width: "100%",
      overflowX: "auto",
      whiteSpace: "nowrap",
    },
  },

  howit__workSection: {
    position: "relative",
    "& h2": {
      fontWeight: "800",
      fontFamily: "Inter",
      fontSize: "200px",
      color: "#0C091B",
      background:
        "linear-gradient(45deg, rgba(225, 64, 132, 1) 0%, rgba(52, 84, 250, 1) 47%, rgba(84, 181, 187, 1) 80%)",
      "-webkit-background-clip": "text",
      "-webkit-background-clip": "text",
      "background-clip": "text",

      width: "100%",
      textAlign: "center",
      textTransform: "uppercase",
      "-webkit-text-stroke": " 4px transparent",
      "@media (max-width:1024px)": {
        display: "none",
      },
      "@media (max-width:767px)": {
        display: "none",
      },
    },
    "& h3": {
      color: "#fff",
      fontSize: "35px",
      fontWeight: "bold",
      position: "absolute",
      top: "43px",
      left: "0",
      right: "0",
      "@media (max-width:1024px)": {
        position: "inherit",
        top: "0",
        marginBottom: "30px",
        fontSize: "35px",
      },
      "@media (max-width:767px)": {
        position: "inherit",
        top: "0",
        marginBottom: "30px",
        fontSize: "25px",
      },
    },
  },
  Influencer__FanHeading: {
    "& h3": {
      fontSize: "35px",
      color: "#fff",
      fontWeight: "700",
      marginBottom: "40px",
    },
  },
  fan__PartnersLogo: {
    backgroundColor: "#2A3346 !important",
    padding: "36px 10px",
    textAlign: "center",
    borderRadius: "0 !important",
    cursor: "pointer",
    "-webkit-transition": "0.4s ease !important",
    transition: "0.4s ease !important",
    width: "100%",
    "&:hover": {
      // backgroundColor: "#23304a !important",
      backgroundImage:
        "linear-gradient(to right, #E14084 0%, #3454FA 53.16%, #54B5BB 100%)",
      boxShadow: "1px 1px 8px 1px #4486d4",
      "-webkit-transform": "scale(1.2)",
      transform: "scale(1.2)",
    },
    "@media (max-width:480px)": {
      width: "300px",
    },
  },
}));

function Partners(props) {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:768px)");

  const [news, setNews] = useState([]);
  const [newsLength, setNewsLength] = useState("");
  const { data: homeNewsData } = useQuery(
    `${STRAPI_API_URL}/press-releases`,
    () =>
      fetcher.get(`${STRAPI_API_URL}/press-releases`, {
        params: {
          populate: "*",
        },
      })
  );

  useEffect(() => {
    if (homeNewsData) {
      setNews(homeNewsData.data);
      setNewsLength(homeNewsData.data.length);
    }
  }, [homeNewsData]);

  return (
    <>
      <section className={classes.fan__singerSlider}>
        <Container maxWidth="lg">
          <div
            className={
              props?.Influencer == "Influencer"
                ? classes.Influencer__FanHeading
                : classes.howit__workSection
            }
          >
            {props?.Influencer == "Influencer" ? (
              <></>
            ) : (
              <Typography variant="h2">News</Typography>
            )}

            <Typography variant="h3" textAlign={"center"}>
              We are on News!
            </Typography>
          </div>
          <Box
            className={
              props?.Influencer == "Influencer"
                ? classes.test2
                : classes.fan__PartnersSection
            }
            sx={{ width: "100%" }}
          >
            {news &&
              news?.map((data) => {
                return (
                  <Card
                    key={data?.id}
                    className={classes.fan__PartnersLogo}
                    onClick={() => {
                      window.open(data.attributes.external_link, "_blank");
                    }}
                  >
                    <img
                      src={data.attributes.media_logo.data[0].attributes.url}
                      alt="news image"
                    />
                  </Card>
                );
              })}
          </Box>
        </Container>
      </section>
    </>
  );
}

export default Partners;
